<template>
  <div>
    <div class="info" v-if="verification">
      {{ $t('discount.voucher.voucher.info', { cardType: verification.cardType }) }}
    </div>
    <div v-if="voucher" class="voucher-wrapper">
      <voucher-display :voucher="voucher" />
      <div class="redeem-info">
        {{ $t('discount.voucher.voucher.redeemInfo', { providerName: provider.name }) }}
      </div>
      <div class="voucher-info-wrapper">
        <div v-if="!!benefit.voucherInfo" class="voucher-info-title">
          {{ $t('discount.voucher.voucher.voucherInfo') }}
        </div>
        <L10n :item="benefit" name="voucherInfo" html />
      </div>
      <div class="voucher-validity">
          {{ $t('discount.voucher.voucher.validTo') }}:
          {{ voucherValidity }}
      </div>
      <a v-if="redeemLink" :href="redeemLink" target="_blank"
          class="primary-button">
        {{ $t('discount.voucher.voucher.redeemButton') }}
      </a>
    </div>
  </div>
</template>
<style scoped>
  .primary-button {
    margin-top: 16px;
    max-width: 150px;
  }
  .voucher-info-title {
    margin-top: 16px;
    font-weight: bold;
    margin-bottom: -8px;
  }
  .voucher-validity {
    margin-top: 16px;
    font-weight: bolder;
  }

</style>
<script>
import { mapState } from 'vuex';
import VoucherDisplay from '../VoucherDisplay.vue';
import L10n from '../../L10n.vue';

export default {
  name: 'voucher-step',
  computed: {
    ...mapState({
      verification: (state) => state.voucher.verification,
      benefit: (state) => state.voucher.benefit,
      locale: (state) => state.config.locale,
      providerBenefits: (state) => state.provider.detail.benefits,
      provider: (state) => state.provider.detail.provider,
      voucher: (state) => state.voucher.voucher,
      benefitLink: (state) => state.benefit.benefitLink,
    }),
    voucherValidity() {
      const date = new Date(this.voucher.validTo);
      const formatter = new Intl.DateTimeFormat('en-GB', { dateStyle: 'short', timeZone: 'UTC' });
      return formatter.format(date);
    },
    redeemLink() {
      return !this.benefitLink ? this.benefit.webUrl : this.benefitLink;
    },
  },
  components: {
    VoucherDisplay,
    L10n,
  },
};
</script>
